// extracted by mini-css-extract-plugin
module.exports = {"primary":"_2MAGkmHE_Kl-X7judcCOcG","secondary":"_31ydna0GyhpAPEuZKH6dYQ","tertiary":"_1yokpFdxz52l2zTaoJGazX","invisible":"_2m34cUaoQWYI4QWqoJZgIq"};